import { isMaliciousUrl } from './../link/is-malicious-url.js';
import { normalizeHref } from './../link/normalize-href.js';

import { getBasedUrl } from './get-based-url.js';
import { isPageUrl } from './is-page-url.js';

export const getHrefUrl = (url: string, baseUrl?: string): string | undefined =>
  typeof url !== 'string'
    ? undefined
    : isMaliciousUrl(url)
    ? undefined
    : isPageUrl(url)
    ? getBasedUrl(url, baseUrl || '')
    : normalizeHref(url);
